import { printHtmlNodesToJsx, printHtmlNodesToText, generateJsxKey } from '@utils/ast';
import { PM2GeogebraComponent } from './comp.root.js';
import { jsx } from 'react/jsx-runtime';

const printGeogebraComponent = (node, context) => {
  return /*#__PURE__*/jsx(PM2GeogebraComponent, {
    component: node.component,
    displayMode: node.options.displayMode,
    isScrambled: node.pm2.isScrambled,
    previewImage: node.meta.previewImage,
    indexOrLevel: node.meta.indexOrLevel,
    lightboxDescription: printHtmlNodesToText(node.meta.lightboxDescription ?? []),
    richtextDescription: printHtmlNodesToJsx(node.meta.richTextDescription),
    node: node,
    onResetEntry: undefined
  }, generateJsxKey(context));
};
const geogebraComponentJsxPrinters = {
  "component-framework.geogebra": printGeogebraComponent
};

export { geogebraComponentJsxPrinters, printGeogebraComponent };
//# sourceMappingURL=printer.to-jsx.js.map
